/**
 * This module defines general, application-wide constants
 */

// Misc locations
export const IMAGE_DIR = 'static/images/';

// Action identifiers
export const SET_AUTHENTICATION_STATE = 'SET_AUTHENTICATION_STATE';
export const INIT_DATA_CLIENT = 'INIT_DATA_CLIENT';
export const INITIALIZE_APP = 'INIT_APP';
export const TERMINATE_APP = 'TERM_APP';
export const LOAD_CACHE = 'LOAD_CACHE';
export const FAIL_CACHE = 'FAIL_CACHE';
export const CLEAR_CACHE = 'CLEAR_CACHE';
export const SET_VIEW_STATE = 'SET_VIEW_STATE';
export const SET_LANGUAGE = 'SET_LANGUAGE';

// Main view identifiers
export const CONDITIONS_VIEW = 'CONDITIONS';
export const GRIDS_VIEW = 'GRIDS';
export const ANALYSIS_VIEW = 'ANALYSIS';
export const SENSORS_VIEW = 'SENSORS';
export const ALERTS_VIEW = 'ALERTS';
export const LIVE_METRICS_VIEW = 'LIVE_METRICS';

// Chart type identifiers
export const SERIES_CHART = 'series';
export const VELOCITY_CHART = 'velocity';

// Series identifiers
export const SERIES1_ID = 'series1';
export const SERIES2_ID = 'series2';

// Supported calc function identifiers
export const CALC_MIN = 'MIN';
export const CALC_MAX = 'MAX';
export const CALC_AVG = 'AVG';
export const CALC_LAST = 'LAST';

// Time intervals
export const YEAR_INTERVALS = 'YEAR';
export const MONTH_INTERVALS = 'MONTH';
export const WEEK_INTERVALS = 'WEEK';
export const DAY_INTERVALS = 'DAY';
export const HOUR_INTERVALS = 'HOUR';
export const MINUTE_INTERVALS = 'MINUTE';
export const SECOND_INTERVALS = 'SECOND';

// Severities
export const SEVERITY_NORMAL = 'INFO';
export const SEVERITY_WARNING = 'WARNING';
export const SEVERITY_ALERT = 'CRITICAL';

// TargetTypes
export const TARGET_SITE = 'SITE';
export const TARGET_GRID = 'GRID';
export const TARGET_PEN = 'PEN';

// Time frame presets
export const TODAY_TIMEFRAME = 'TODAY';
export const YESTERDAY_TIMEFRAME = 'YESTERDAY';
export const PAST_24HOURS_TIMEFRAME = 'PAST_24HOURS';
export const PAST_7DAYS_TIMEFRAME = 'PAST_7DAYS';
export const PAST_30DAYS_TIMEFRAME = 'PAST_30DAYS';
export const PAST_60DAYS_TIMEFRAME = 'PAST_60DAYS';
export const PAST_90DAYS_TIMEFRAME = 'PAST_90DAYS';
export const PAST_120DAYS_TIMEFRAME = 'PAST_120DAYS';
export const PAST_180DAYS_TIMEFRAME = 'PAST_180DAYS';
export const PAST_YEAR_TIMEFRAME = 'PAST_YEAR';
export const DAYSBACK_TIMEFRAME = 'DAYS_BACK';
export const DATERANGE_TIMEFRAME = 'DATE_RANGE';

// Common resource names
export const FARM_RESOURCE = 'FARMS';
export const SITE_RESOURCE = 'SITES';
export const GRID_RESOURCE = 'GRIDS';
export const PEN_RESOURCE = 'PENS';
export const METRIC_RESOURCE = 'METRICS';
export const VECTOR_RESOURCE = 'VECTORS';
export const SENSOR_RESOURCE = 'SENSORS';
export const METRIC_CATEGORY_RESOURCE = 'METRIC_CATEGORIES';
export const METRIC_TYPE_RESOURCE = 'METRIC_TYPES';
export const METRIC_VALUE_RESOURCE = 'METRIC_VALUES';
export const UNIT_RESOURCE = "UNITS";
export const ALERTS_RESOURCE = 'ALERTS';
export const ALERT_BREAKDOWN_RESOURCE = 'ALERT_BREAKDOWN';
export const GRAPHS_RESOURCE = 'GRAPHS';
export const SITE_METRICS_RESOURCE = 'SITE_METRICS';
export const SITE_VECTORS_RESOURCE = 'SITE_VECTORS';

// Graph identifiers
export const SENSOR_STATUS_GRAPH_ID = "sensor_status";
export const SITE_VECTORS_GRAPH_ID = "site_vectors";
export const SITE_ALERTS_GRAPH_ID = "site_alerts";
export const LIVE_SITE_METRICS_GRAPH_ID = "live_site_metrics";

// General ui-component orientations
export const ORIENTATION_VERTICAL = 'vertical';
export const ORIENTATION_HORIZONTAL = 'horizontal';

// SVG color gradient clue
export const RANGE_DIRECTION_UP = "UP";
export const RANGE_DIRECTION_DOWN = "DOWN";

// Common field names
export const METRIC_ID_FIELD = 'metricId';
export const INTERVAL_VALUE_FIELD = 'intervalValue';

// Supported Languages
export const LANG_ENGLISH = "en";
export const LANG_SPANISH = "es";

// Fetch related
export const FETCH_BASE_PATH='api/';
export const FETCH_CONFIG_PATH='config';
export const FETCH_METRIC_DOWNLOAD_PATH='metric_download';
export const FETCH_VECTOR_DOWNLOAD_PATH='vector_download';
export const FETCH_RESOURCE_CACHE_PATH='resource_cache';
export const FETCH_RESOURCES_PATH='resources';
export const FETCH_VECTORS_PATH='vectors';

export const MAX_DOWNLOAD_RECORDS = 1000;